module.exports = __webpack_public_path__ + "static/media/44452589_2199882730086906_6763359222341042176_o-thumb.955a74ea.jpg";